import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default function useChickenDashboardIntervalReqParams(distReqParams) {
  const interval = useSelector(state => state.chickenDashboard?.interval);
  
  return useMemo(() => {
    if (distReqParams && interval) {
      return { ...distReqParams, intervalInSeconds: interval };
    }
    
    return null;
  }, [distReqParams, interval]);
}
